import React from "react";
import AppBar from "../../Components/header";
import AppProvider from "../../Components/bootstrap";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import moment from "moment";
import {
  ButtonGroup,
  Button,
  Paper,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Loading } from "react-admin";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Parse from "parse";
import { useEffect } from "react";
import EventIcon from "@material-ui/icons/Event";
import ScheduleIcon from "@material-ui/icons/Schedule";
import Chip from "@material-ui/core/Chip";
import Link from "@material-ui/core/Link";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useAuthenticated} from "react-admin"

import { createMuiTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  main: {
    marginTop: "8%",
    background: "transparent",
  },
  mainSm: {
    marginTop: "15%",
    background: "transparent",
  },
  buttons: {
    margin: "10% 0",
  },
  list: {
    margin: "1%",
  },
  listHeader: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "73.33%",
    flexShrink: 0,
  },
  listHeaderSm: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  dateTimeDetails: {
    flexBasis: "10.33%",
    fontSize: theme.typography.pxToRem(15),
    fontWeight: "400",
    marginLeft: ".3rem",
  },
  dateTimeDetailsSm: {
    flexBasis: "30.33%",
    fontSize: theme.typography.pxToRem(15),
    fontWeight: "400",
    marginLeft: ".3rem",
  },
  icons: {
    marginTop: ".1rem",
    fontSize: "1.4rem",
    color: "rgb(167, 91, 58)",
  },
  chips: {
    color: "#fff",
    margin: ".2rem",
  },
  paper: {
    marginLeft: "-.2rem",
  },
  panel: {
    minWidth: "70vw",
    margin: "auto",
  },
}));

const mentorTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#EF8354",
    },
  },
});

const MyAppointments = () => {
  const classes = useStyles();
  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));
  const user = Parse.User.current();
  const [type, setType] = React.useState("CREATOR");
  useAuthenticated()
  const handleClick = (type) => (event) => {
    setType(type);
    console.log(`Appointment Type: ${type}`);
  };

  return (
    <AppProvider>
      <AppBar />
      <Paper
        elevation={0}
        className={isDesktop ? classes.main : classes.mainSm}
      >
        <Grid container direction="column" alignItems="center">
          <Grid item xs={12}>
            <ButtonGroup
              className={classes.buttons}
              size="large"
              variant="contained"
              color="primary"
              aria-label="contained primary button group"
            >
              <Button onClick={handleClick("CREATOR")}>Created</Button>
              <Button onClick={handleClick("INVITEE")}>Invited</Button>
            </ButtonGroup>
          </Grid>
          <Grid item xs={12}>
            <AppointmentList
              className={classes.list}
              currentUser={user}
              appointmentType={type}
            />
          </Grid>
        </Grid>
      </Paper>
    </AppProvider>
  );
};

const AppointmentList = ({ currentUser, appointmentType }) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));
  //   const [expanded, setExpanded] = React.useState(false);
  const [appointmentList, setAppointmentList] = React.useState();
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    setLoading(true);
    setAppointmentList(null);
    const AppointmentInvities = Parse.Object.extend("AppointmentInvities");
    const query = new Parse.Query(AppointmentInvities);
    const Appointment = new Parse.Object.extend("Appointment");
    const q = new Parse.Query(Appointment);
    query.equalTo("userId", currentUser.id);
    query.equalTo("type", appointmentType);
    const result = query.find();
    result.then(
      (resp) => {
        let arr = [];
        for (let a = 0; a < resp.length; a++) {
          arr.push(resp[a].get("appointmentId"));
        }
        q.containedIn("objectId", arr);
        const result = q.find();
        result.then(
          (resp) => {
            setAppointmentList(
              resp.map((value) => ({
                id: value.id,
                ...value.attributes,
              }))
            );
            setLoading(false);
          },
          (err) => {
            console.log("Error", err);
            setAppointmentList(err);
            setLoading(false);
          }
        );
      },
      (err) => {
        console.log("Error", err);
        setAppointmentList(err);
        setLoading(false);
      }
    );
  }, [currentUser, appointmentType]);

  /**
   * expand logic
   */
  //   const handleChange = (panel) => (event, isExpanded) => {
  //     setExpanded(isExpanded ? panel : false);
  //   };
  console.log("appointmentList", appointmentList);
  return (
    <div className={classes.list}>
      {loading ? (
        <Loading />
      ) : (
        appointmentList.map((a) => {
          const ZoomMeeting = a.hasOwnProperty("zoomMeeting")
            ? JSON.parse(a.zoomMeeting)
            : "";
          console.log("ZoomMeeting", ZoomMeeting);
          return (
            <ExpansionPanel
              // expanded={
              //   expanded === ZoomMeeting.hasOwnProperty("uuid")
              //     ? ZoomMeeting.uuid
              //     : ""
              // }
              // onChange={handleChange(
              //   ZoomMeeting.hasOwnProperty("uuid") ? ZoomMeeting.uuid : ""
              // )}
              className={classes.panel}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`${
                  ZoomMeeting.hasOwnProperty("uuid") ? ZoomMeeting.uuid : ""
                }-content`}
                id={`${
                  ZoomMeeting.hasOwnProperty("uuid") ? ZoomMeeting.uuid : ""
                }-header`}
              >
                <Typography
                  className={
                    isDesktop ? classes.listHeader : classes.listHeaderSm
                  }
                >{`Mentor : ${a.mentor.name}`}</Typography>
                <EventIcon className={classes.icons} />
                <Typography
                  className={
                    isDesktop
                      ? classes.dateTimeDetails
                      : classes.dateTimeDetailsSm
                  }
                >
                  {moment(a.appointmentDate).format("DD/MM/yyyy")}
                </Typography>
                <ScheduleIcon className={classes.icons} />
                <Typography className={classes.dateTimeDetails}>
                  {a.appointmentTime}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Grid container direction="row" spacing={4}>
                  <Grid item xs={12} md={6}>
                    <Grid container direction="column">
                      <Grid item>
                        <Typography variant="h6">Invitees</Typography>
                      </Grid>
                      <Grid item>
                        <Paper elevation={0} className={classes.paper}>
                          {a.mentees.map((m) => {
                            return (
                              <Chip
                                color="primary"
                                label={m.name}
                                key={m.id}
                                className={classes.chips}
                              />
                            );
                          })}
                        </Paper>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Grid container spacing={2} direction="column">
                      <Grid item>
                        <Typography variant="h6">Meeting Details</Typography>
                      </Grid>
                      <Grid item>
                        <Grid container direction="column" spacing={2}>
                          <Grid item>
                            <Grid container direction="row">
                              <Grid item md={4} sm={6}>
                                <Typography variant="body2">
                                  Meeting ID
                                </Typography>
                              </Grid>
                              <Grid item md={4} sm={6}>
                                <Typography variant="body2">
                                  {ZoomMeeting.hasOwnProperty("id")
                                    ? ZoomMeeting.id
                                    : ""}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item>
                            <Grid container direction="row">
                              <Grid item md={4} sm={6}>
                                <Typography variant="body2">
                                  Duration
                                </Typography>
                              </Grid>
                              <Grid item md={4} sm={6}>
                                <Typography variant="body2">
                                  {a.duration} mins
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item>
                            <Grid container direction="row">
                              <Grid item md={4} sm={6}>
                                <Typography variant="body2">
                                  {appointmentType === "CREATOR"
                                    ? `Start Meeting`
                                    : `Join Meeting`}
                                </Typography>
                              </Grid>
                              <Grid item md={4} sm={6}>
                                <Link
                                  href={
                                    ZoomMeeting.hasOwnProperty("join_url")
                                      ? ZoomMeeting.join_url
                                      : ""
                                  }
                                >
                                  Click Here
                                </Link>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          );
        })
      )}
    </div>
  );
};

export default MyAppointments;
